import type { TableQueryParams } from "../../types/api"

export function buildTableQueryParams(params: TableQueryParams = {}): string {
  const search = new URLSearchParams()
  if (params.page) search.set("page", String(params.page))
  if (params.pageSize) search.set("pageSize", String(params.pageSize))
  if (params.search) search.set("search", params.search)
  if (params.sortBy) search.set("sortBy", params.sortBy)
  if (params.sortOrder) search.set("sortOrder", params.sortOrder)
  if (params.filters?.length) {
    search.set("filters", JSON.stringify(params.filters))
  }
  return search.toString()
}

export function withTableQuery(path: string, params?: TableQueryParams): string {
  const query = buildTableQueryParams(params)
  if (!query) return path
  return `${path}?${query}`
}
